// @flow
import React, { PureComponent } from 'react';
import { formatFullDate } from 'utils/dateUtils';
import Label from 'components/fragments/text/Label';
import Figure from 'components/fragments/Figure';
import { Link } from 'react-router-dom';
import type { BlocContent } from 'types/NewsletterBloc';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';

type Props = {
  label?: string,
  date?: Date,
  title?: string,
  imgLink: string,
  imgCaption?: string,
  video: Array<BlocContent>
};

class ArticleHeader extends PureComponent<Props> {
  static defaultProps = {
    label: '',
    date: '',
    title: '',
    imgCaption: '',
    imgLink: '',
    video: []
  };

  renderTrueBlocs = (blocs: Array<BlocContent>): any => {
    return blocs.map((blocFigure, index) => <ContentBloc key={index} {...blocFigure} />);
  };

  render() {
    const { label, date, title, imgCaption, imgLink, video } = this.props;
    const illustration_video = video.length > 0;
    const displayDate = date ? formatFullDate(date) : '';

    return (
      <div className="col col-lg-8on9">
        <p className="article__meta mt-lg-6">
          <Label label={label} />
          { date && 
          <span className="article__date ft-h6">
            <time dateTime={date.toISOString()}>{displayDate}</time>
          </span> }
        </p>
        <h1 className="article__title">{title}</h1>
        { illustration_video &&
        this.renderTrueBlocs(video) }
        { ! illustration_video &&
        <Figure
          containerClassName="article__cover"
          figureClassName="article__thumbnail"
          caption={imgCaption}
          src={imgLink}
          articleTitle={title}
        /> }
        <div className="article__topbar">
          <div>
            <Link to="#" className="btn btn--icon btn--icon btn--medium">
              <i className="icon icon-arrow-up " />
            </Link>
            <div className="article__topbar-social">
              <Link
                className="btn btn--social btn--medium btn--facebook btn--social"
                to="#"
                target="_blank"
                rel="nofollow"
              >
                <i className="icon icon-facebook" />
              </Link>
              <Link
                className="btn btn--social btn--medium btn--twitter btn--social"
                to="#"
                target="_blank"
                rel="nofollow"
              >
                <i className="icon icon-twitter" />
              </Link>
              <Link
                className="btn btn--social btn--medium btn--primary btn--social"
                to="#"
                target="_blank"
                rel="nofollow"
              >
                <i className="icon icon-mail" />
              </Link>
            </div>
            <div>
              <Label label="ligue" />
              <p className="ft-h5 ft-truncat">{title}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ArticleHeader;
